import { useTranslation } from "react-i18next";
import ExpandableText from "../../../../components/app/ExpandableText";
import ScientificText from "../../../../components/ScientificText";
import type { ArticlePageArticle } from "../../hooks/useArticleData";
import { SectionTitle } from "../../../../components/ui/SectionTitle";

interface ArticleSectionBackgroundProps {
  article: ArticlePageArticle;
  isExpanded: boolean;
  setExpand: (isExpanded: boolean) => void;
}

export function ArticleSectionBackground({
  article,
  isExpanded,
  setExpand,
}: ArticleSectionBackgroundProps) {
  const { t } = useTranslation();
  const background = article.background;

  if (!background) return null;

  return (
    <section data-gtm-section="background" data-gtm-order="2">
      <SectionTitle title={t("Background")} className="mb-4" />
      <ExpandableText isExpanded={isExpanded} setExpand={setExpand} lines={10}>
        <ScientificText>{background}</ScientificText>
      </ExpandableText>
    </section>
  );
}
